/**
 * @description Статус отчетности в ИЭМК.
 * @param {string} id    Идентификатор.
 * @param {string} text  Поясняющий текст.
 * @param {string} title Заголовок.
 * @constructor
 */
function IemkReportingStatus(id, text, title) {
  /**
   * @description Получить идентификатор.
   * @returns {string}
   */
  this.getId = () => id;
  /**
   * @description Получить поясняющий текст.
   * @returns {string}
   */
  this.getText = () => text;
  /**
   * @description Получить заголовок.
   * @returns {string}
   */
  this.getTitle = () => title;
}

export const makeStatusBySchema = (raw) => new IemkReportingStatus(raw.id, raw.text, raw.title);

export default {
  makeStatusBySchema,
};
